<template>
  <el-dialog
    title="选择企业"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <div class="search-form">
      <el-input
        v-model="config.vendorName"
        placeholder="请输入企业名称"
        style="width: 200px"
        class="input-with-select">
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="()=> {fetchList()}"></el-button>
      </el-input>
    </div>
    <el-table
      v-loading="loading"
      border
      max-height="400"
      :data="list">
      <el-table-column
        label="企业名称"
        prop="vendorName"></el-table-column>
      <el-table-column
        label="是否过滤"
        width="210">
        <template slot-scope="{row}">
          <el-switch
            :value="row.cclassId"
            :active-value="config.cclassId"
            :inactive-value="null"
            @change="(v) => {onChane(v, row.vendorId)}">
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total"
      @current-change="handleCurrentChange">
    </el-pagination>
    <div slot="footer">
      <el-button
        type="primary"
        @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EntSettingModal',
  components: {},
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        vendorName: ''
      },
      total: 0
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.config = {
        pageNum: 1,
        pageSize: 10,
        vendorName: ''
      }
    },
    handleCurrentChange(cur) {
      this.config.pageNum = cur
      this.fetchList()
    },
    onChane(v, vendorId) {
      console.log(v)
      const postData = {}
      if (v) {
        postData.addExcludes = [{
          name: this.config.name,
          cclassId: this.config.cclassId,
          templateType: this.config.templateType
        }]
      } else {
        postData.deleteExcludes = [{
          name: this.config.name,
          cclassId: this.config.cclassId,
          templateType: this.config.templateType
        }]
      }
      this.loading = true
      this.$store.dispatch('industry/setfieldh5displayexcludes', {
        payload: {
          vendorId,
          ...postData
        },
        success: () => {
          this.loading = false
          this.config.pageNum = 1
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('industry/getfieldh5displayexcludes', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row) {
      // console.log(row)
      this.config = {
        ...this.config,
        cclassId: row.classId,
        templateType: row.templateType,
        name: row.name
      }
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
